<template>
  <div class="newsletter" v-if="userData">
    <div class="hero">
    </div>
    <div class="form">
      <p>{{ $t('newsletter.title') }}</p>
      <label class="form__label" for="usermail">{{ $t('newsletter.emailLabel') }}</label>
      <input v-bind:class="{form__input:true, error:formError}" type="email" :placeholder="$t('newsletter.emailPlaceholder')" id="usermail" v-model="userMail">
      <div class="form__check" v-if="userMail">
        <input type="checkbox" id="newsletter" v-model="newsletter">
        <label for="newsletter"><span></span>{{ stationData.newsletter_label }}</label>
      </div>
    </div>
    <a v-bind:class="{ inactive: loading }" class="btn-start btn" href="#" @click.prevent="proceed">{{ $t('newsletter.next') }}</a>
  </div>
</template>

<script>
import {Howl, Howler} from 'howler';
import axios from 'axios';

export default {
  name: 'Newsletter',
  props: ['userData', 'stationData'],
  mounted() {
  },
  data: () => {
    return {
      userMail: '',
      newsletter: false,
      loading: false,
      formError: false
    }
  },
  methods: {
    proceed() {
      let url = window.apiUrl + '/api/visitors/' + this.userData.id;
      this.loading = true;

      axios.put(url, {
        email: this.userMail,
        newsletter: this.newsletter,
        finished: true
      })
      .then((data) => {
        this.formError = false;
        this.$emit('navigate', 'Finale');
      })
      .catch((error) => {
        this.loading = false;
        this.formError = true;
        console.log(error);
      });
      
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">

.newsletter {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;  
}
.hero {
  background-color: var(--white);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20vh;
  z-index: 1;
  display: none;
}

.form {
  padding: 10rem 6rem 0 6rem;
  font-family: 'Syntax';
  // text-align: center;

  p {
    max-width: 32rem;
    line-height: 1.4;
    margin: 0;
    margin-bottom: 3rem;
    font-size: 2rem;
    font-family: 'GT Sectra';
  }

  &__label {
    display: block;
    font-size: 1.25rem;
  }
  &__input {
    font-family: 'Syntax';
    font-size: 1.25rem;
    padding: 1rem 1.5rem;
    border: 2px solid rgba(#212121, .4);
    background: var(--white);
    width: 100%;
    box-sizing: border-box;
    margin-top: .5rem;
    // text-align: center;

    &:focus {
      outline: none;
      border-color: #212121;
    }
    &::placeholder {
      color: #ccc;
    }
    &.error {
      border-color: #f00;
    }
  }
  &__check {
    margin-top: 1.5rem;
    input {
      display: none;

      &:checked + label span::before {
        opacity: 1;
        transition: 0s opacity;
      }
    }
    label {
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        width: 1.5rem;
        height: 1.5rem;
        background-color: var(--white);
        border: 2px solid var(--black);
        margin-right: 1rem;
        position: relative;

        &::before {
          content: "✕";
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          text-align: center;
          font-size: 1.25rem;
          line-height: 1.5rem;
          pointer-events: none;
          opacity: 0;
          transition: .3s opacity;
        }
      }
    }
  }
}
.subtitle {
  opacity: .5;
}
h2 {
  font-size: 3rem;
  font-family: 'GT Sectra', serif;
  margin: 0;
}
p {
  font-size: 1.25rem;
  max-width: 30rem;
  margin: 1rem auto;
}
.btn-start {
  position: absolute;
  top: 38rem;
  left: 6rem;
  width: calc(100% - 12rem);
  margin: 0;

  &.inactive {
    pointer-events: none;
    opacity: .5;
  }
}

@keyframes bounce-in {
  from {
    transform: scale(.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

</style>
